import { HttpInterceptorFn } from '@angular/common/http'
import { environment } from '../../../../environments/environment'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem(environment.token)
  if (token) {
    return next(
      req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      })
    )
  }
  return next(req)
}
